import React, { Component, createRef, useMemo } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ShipperReceiverForm from "./ShipperReceiverForm";
import {
  getBookingObject,
  updateBookingDataCharges,
} from "../../util/getBookingInfo";
import TransparentOverlay from "../form-section/TransparentOverlay";
import ShipperReceiverForm2 from "./ShipperReceiverForm2";
import {
  buttonStyle,
  formSubmissionErrorStyle,
  stepStyle,
  stepStyle2,
} from "./styles";

import { Form, Icon, Select, Row, Col, Button, Typography, Result } from "antd";

const { Title } = Typography;

const errorDivRef = React.createRef();
class ShipperInfoForm extends React.Component {
  state = {
    country: "",
    phoneNumber: "",
    bookingData: {},
    token: {},
    isFormSubmissionError: false,
    currentStep: 1,
    showCustomBrokerInput: false,
    shipperReceiverForm1: {
      email: "",
      customer_first_name: "",
      customer_last_name: "",
      phone: "",
      company_name: "",
      street: "",
      address: "",
      city: "",
      state: "",
      postal: "",
      country: "",
      custom_broker: "primeFreight",
      custom_broker_name: "",
      insurance: "",
      dutyTax: [{}],
    },
    shipperReceiverForm2: {
      account_consent: true,
      agreement: false,
      shipment_price:
        this.props?.final_search_form?.selected_card_json?.bookNowPrice ||
        "0.00",
    },
    dutyTax: [{}],
    commodityArr: [{}],
    insuranceArr: [{}],
    dutyTax_amount_subtotal: {
      duties: 0,
      taxes: 0,
    }, // State to store dutyTax_amount_subtotal
    resultBookingId: "",
    bookingDatacharges: {},
  };

  getPrice = () => {
    const { final_search_form } = this.props;
    const { dutyTax_amount_subtotal, insuranceArr } = this.state;
    const previousFormData = this.state.shipperReceiverForm1;
    const rate =
      final_search_form &&
      final_search_form.selected_card_json &&
      final_search_form.selected_card_json.bookNowPrice
        ? Number(final_search_form?.selected_card_json?.bookNowPrice)
        : 0;

    let brokerFee = 0;
    let insuranceAmount = 0;
    if (previousFormData?.custom_broker === "primeFreight") {
      brokerFee = 75;
    }

    if (insuranceArr && insuranceArr.length > 0) {
      insuranceAmount = insuranceArr?.reduce((sum, item) => {
        const premiumAmount = Number(item.quote?.premium_amount) || 0;
        return sum + (isNaN(premiumAmount) ? 0 : premiumAmount);
      }, 0);
    }
    const totalDutyTaxAmount =
      dutyTax_amount_subtotal.duties + dutyTax_amount_subtotal.taxes;
    // console.log(
    //   "broker fee: ",
    //   brokerFee,
    //   "insuranceAmount: ",
    //   insuranceAmount,
    //   "totalDutyTaxAmount: ",
    //   totalDutyTaxAmount
    // );
    const totalAmount = (
      rate +
      brokerFee +
      insuranceAmount +
      totalDutyTaxAmount
    ).toFixed(2);
    return totalAmount;
  };

  handleDutyTaxAmountSubtotalChange = (amountSubtotal) => {
    this.setState({
      dutyTax_amount_subtotal: {
        duties: amountSubtotal?.Duty,
        taxes: amountSubtotal?.VAT,
      },
    });
  };

  handleAddCommodity = () => {
    const { commodityArr } = this.state;
    this.setState({
      commodityArr: [
        ...commodityArr,
        {
          category: "",
          description: "",
          commodityValue: "",
        },
      ],
    });
  };

  handleDeleteCommodity = (index) => {
    const { commodityArr } = this.state;
    let commodityFiltered = commodityArr.filter((_, idx) => idx !== index);
    this.setState({
      //dutyTax: [...dutyTaxFiltered],
      commodityArr: commodityFiltered,
    });
    this.props.form.setFieldsValue({ commodityArr: commodityFiltered });
  };

  handleCommodityChange = (index, key, value) => {
    const { commodityArr } = this.state;
    commodityArr[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ commodityArr });
    //this.setState({ showDutyTaxError: false });
  };

  handleInsuranceAmountChange = (insuranceArr) => {
    this.setState({ insuranceArr: insuranceArr });
  };

  handleDutyTaxChange = (index, key, value) => {
    const { dutyTax } = this.state;
    dutyTax[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ dutyTax });
  };

  handleAddDutyTax = () => {
    const { dutyTax } = this.state;
    this.setState({
      dutyTax: [...dutyTax, {}],
    });
  };

  handleDeleteDutyTax = (index) => {
    const { dutyTax } = this.state;
    dutyTax.splice(index, 1);
    this.setState({
      dutyTax: [...dutyTax],
    });
  };

  handleNextSubmit = async (e) => {
    //console.log("handle submit NEXT Button is executing..................");
    e.preventDefault();
    const {
      final_search_form,
      jwt_token,
      booking_customer_form,
      queryParams,
      agentInformation,
      transactionType,
    } = this.props;

    let bookingDatacharges = getBookingObject(
      final_search_form,
      queryParams,
      agentInformation,
      transactionType
    );
    // console.log("--bookingDatacharges-- :", bookingDatacharges);

    if (this.state.currentStep === 1) {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          // increment the step
          this.setState((prevState) => ({
            currentStep: prevState.currentStep + 1,
          }));
          this.setState({
            isFormSubmissionError: false,
            shipperReceiverForm1: values,
          });
        } else {
          this.setState({ isFormSubmissionError: true });
          if (errorDivRef.current) {
            errorDivRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    } else if (this.state.currentStep === 2) {
      // Handle form submission for step 2
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          this.setState({
            isFormSubmissionError: false,
            shipperReceiverForm2: values,
          });
          // console.log(
          //   "\ncustomer form data: ",
          //   booking_customer_form,
          //   "\nShipperReceiverForm1: ",
          //   this.state.shipperReceiverForm1,
          //   "\nnShipperReceiverForm2: ",
          //   values,
          //   "\nDuty and tax: ",
          //   this.state.dutyTax_amount_subtotal,
          //   "\nCargo insurance info: ",
          //   this.state.insuranceArr
          // );

          const updatedBookingDataCharges = updateBookingDataCharges(
            bookingDatacharges,
            this.state.shipperReceiverForm1,
            this.state.dutyTax_amount_subtotal
          );
          // console.log(
          //   ".....................updateBookingDataCharges....................",
          //   updatedBookingDataCharges
          // );
          this.setState({ bookingDatacharges: updatedBookingDataCharges });
          let insurance = [];
          const isEmptyObject = (obj) => Object.keys(obj).length === 0;

          const isArrayEmptyOrContainingOnlyEmptyObjects = (arr) => {
            return arr.length === 0 || arr.every(isEmptyObject);
          };
          if (
            !isArrayEmptyOrContainingOnlyEmptyObjects(this.state.insuranceArr)
          ) {
            insurance = this.state.insuranceArr;
          }

          const result = await this.props.Create_New_Booking_Landing_Page(
            jwt_token,
            updatedBookingDataCharges,
            booking_customer_form,
            this.state.shipperReceiverForm1,
            values,
            insurance,
            this.state.dutyTax_amount_subtotal
          );
          // console.log("-----------------result-----------------: ", result);
          if (result) {
            this.setState((prevState) => ({
              currentStep: prevState.currentStep + 1,
            }));
            //this.setState({resultBookingId: result[1]})
            // this.props.final_booking_button({bookingSuccessful: true,bookingId: result[1]})
          } else {
            this.props.updateErrorAndLoading(
              "Error ! Please Contact Prime Freight",
              undefined
            );
          }
        } else {
          this.setState({ isFormSubmissionError: true });
          if (errorDivRef.current) {
            errorDivRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    } else if (this.state.currentStep === 3) {
      console.log("Step 3 is executing..........");
    }
  };

  handlePrevious = () => {
    const { currentStep } = this.state;
    // Go back to the previous step if currentStep is greater than 1
    if (currentStep > 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  render() {
    return (
      <div ref={errorDivRef} style={{ padding: "2rem 0" }}>
        <Row
          type="flex"
          justify="center" //style={{border:"1px solid red"}}
        >
          <Col xs={20} sm={20} md={16} lg={12}>
            {this.state.isFormSubmissionError ? (
              <div style={formSubmissionErrorStyle}>
                <Icon
                  type="exclamation-circle"
                  style={{ fontSize: "20px", color: "#790000" }}
                  theme="outlined"
                />
                &nbsp;
                <span>
                  There was a problem with your submission. Please review the
                  fields below.
                </span>
              </div>
            ) : (
              ""
            )}

            <Form onSubmit={this.handleSubmit} className="booking-form">
              {/* Section 1 */}
              {this.state.currentStep === 1 && (
                <div>
                  <div style={{ paddingBottom: "1rem" }}>
                    <p style={stepStyle}>Step {this.state.currentStep} of 2</p>
                    {this.props.booking_customer_form.customer_type?.includes(
                      "Importer"
                    ) ? (
                      <div>
                        <Title level={2}>Your Shipper</Title>
                        <p
                          style={{
                            paddingBottom: "1rem",
                            borderBottom: "2px solid black",
                          }}
                        >
                          Who is shipping this cargo
                        </p>
                        <p style={{ paddingTop: "1rem" }}>
                          We will need some information about your shipper. Your
                          shipper will be contacted by Prime Freight or our
                          agent in the region of departure.
                        </p>
                      </div>
                    ) : (
                      <div>
                        <Title level={2}>Your Receiver</Title>
                        <p
                          style={{
                            paddingBottom: "1rem",
                            borderBottom: "2px solid black",
                          }}
                        >
                          We will need some information about your receiver. The
                          receiver will be contacted by Prime Freight.
                        </p>
                      </div>
                    )}
                  </div>
                  <ShipperReceiverForm
                    {...{ form: this.props.form }}
                    initialFormData={this.state.shipperReceiverForm1}
                    dutyTax={this.state.dutyTax}
                    dutyTax_amount_subtotal={this.state.dutyTax_amount_subtotal}
                    handleDutyTaxChange={this.handleDutyTaxChange}
                    handleAddDutyTax={this.handleAddDutyTax}
                    handleDeleteDutyTax={this.handleDeleteDutyTax}
                    handleDutyTaxAmountSubtotalChange={
                      this.handleDutyTaxAmountSubtotalChange
                    }
                    commodityArr={this.state.commodityArr}
                    insuranceArr={this.state.insuranceArr}
                    handleAddCommodity={this.handleAddCommodity}
                    handleDeleteCommodity={this.handleDeleteCommodity}
                    handleCommodityChange={this.handleCommodityChange}
                    handleInsuranceAmountChange={
                      this.handleInsuranceAmountChange
                    }
                  />
                  <Form.Item>
                    <Button
                      type="default"
                      htmlType="submit"
                      style={buttonStyle}
                      onClick={this.handleNextSubmit}
                    >
                      Next
                    </Button>
                  </Form.Item>
                </div>
              )}
              {/* Section 2 */}
              {this.state.currentStep === 2 && (
                <div>
                  <p style={stepStyle2}>Step {this.state.currentStep} of 2</p>

                  <ShipperReceiverForm2
                    {...{ form: this.props.form }}
                    previousFormData={this.state.shipperReceiverForm1}
                    shipperReceiverForm2={this.state.shipperReceiverForm2}
                    insuranceArr={this.state.insuranceArr}
                    dutyTax_amount_subtotal={this.state.dutyTax_amount_subtotal}
                    totalAmount={this.getPrice()}
                  />

                  <div
                    style={{
                      borderBottom: "1px solid #e8e8e8",
                      paddingBottom: "1rem",
                      marginBottom: "1rem",
                    }}
                  ></div>
                  <Form.Item>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Button
                        type="default"
                        style={buttonStyle}
                        onClick={this.handlePrevious}
                      >
                        Previous
                      </Button>
                      <Button
                        type="default"
                        htmlType="submit"
                        style={buttonStyle}
                        onClick={this.handleNextSubmit} //disabled={!this.props.stripe}
                      >
                        submit
                      </Button>
                    </div>
                  </Form.Item>
                  {this.props.saveDataShowOverlay && (
                    <TransparentOverlay message="Please wait..." />
                  )}
                </div>
              )}

              {/* Section 3 */}
              {this.state.currentStep === 3 && (
                <div style={{ backgroundColor: "#FFF" }}>
                  <Result
                    status="success"
                    // title={`Successfully Created a Booking with Booking ID - ${this.state.bookingId}`}
                    title={`Thanks for shipping with us!`}
                    subTitle="Your booking request has been received. We will get in touch with you shortly."
                  />
                </div>
              )}
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

const WrappedShipperInfoForm = Form.create({ name: "register" })(
  ShipperInfoForm
);

ShipperInfoForm.propTypes = {
  /**
   * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories.
   * It also accepts `null`
   */
  final_search_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  //console.log("state.route.queryParams: ",state.route.queryParams)
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    booking_customer_form: state.route.booking_customer_form,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    agentInformation: state.form.AgentInformation,
    saveDataShowOverlay: state.code_config.saveDataShowOverlay,
    transactionType: state.code_config.transactionType,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedShipperInfoForm)
);
